import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { url } from "../../../services/constant";

import { useTheme, useLoyalty } from "../../../hooks";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  Curve,
  CurveOverImage,
  ExpandIcon,
  NewBackButton,
  Phone,
  RightArrow,
  Time as TimeIcon,
  VoiceIcon,
  CollapseIcon,
} from "../../../components/svgs";
import {
  Body,
  Children,
  MainHolder,
  StyledText,
} from "../../../components/common/basic";
import { BackButton, FeatureHeader } from "../../../components/common";

const faq = [
  {
    title: `How do I earn points?`,
    description: `Points are earned by in-app Mashup starting from GHC 0.50`
  },
  {
    title: `Do points have a validity period?`,
    description: `Points building for Speed Shopping starts on 29th November and ends on 19th December, 2022`
  },
  {
    title: `Do I have to subscribe to participate?`,
    description: `No subscription required, just mashup on myMTN app and earn points.`
  },
  {
    title: `Can I redeem my points?`,
    description: `Number of Points built increases your chances of obtaining a reward. Eg. Being selected to participate in speed shopping, or invitation to the Cinema etc`
  },
  {
    title: `How are the points calculated`,
    description: ` By multiplying purchased amount by 10`
  },
];

const SpeedShoppingFaq = () => {
  const { themeContext, theme } = useTheme();
  const { activeTheme } = themeContext;
  const {
    selectedLoyaltyData,
  } = useLoyalty();

  const { promoData: { tailImage } = {} } = selectedLoyaltyData || {};

  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "SpeedShoppingFaq",
      firebase_screen_class: "SpeedShoppingFaq",
    }));
  }, []);
  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => history.goBack()} />
          <FeatureHeader
            image={tailImage}
            title={["Frequently", "Asked", "Questions"]}
            background="#fff"
          />
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '0 15px 30px 15px' }}>
              {
                faq.map(({ title, description }, idx) => (
                  <ExpandablePanel key={idx} title={title} color={background}>
                    <StyledText size={12} style={{ margin: 0, fontFamily: 'MTNRegular' }}>{description}</StyledText>
                  </ExpandablePanel>
                ))
              }
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

// TODO: Move to common components
const ExpandablePanel = ({ title, color, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div style={{ padding: '15px 0', borderBottom: '1px solid #B7BABA', cursor: 'pointer' }}>
      <div onClick={() => setIsExpanded(!isExpanded)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <StyledText size={12} style={{ margin: 0 }} color={isExpanded ? color : '#000'}>{title}</StyledText>
        {
          isExpanded ?
            <div style={{ display: 'flex', alignItems: 'center' }}><CollapseIcon fill={color} /></div> :
            <div style={{ display: 'flex', alignItems: 'center' }}><ExpandIcon fill={color} /></div>}
      </div>
      {
        isExpanded && <div style={{ padding: '10px 0' }}>{children}</div>
      }
    </div>
  )
}

export default SpeedShoppingFaq;
